import { getHomepageLenis } from 'utils/homepageLenis';

/** Anchor for the battery-life footnote at the bottom of the US homepage. */
export const RING_PRO_US_STATS_DISCLAIMER_ID = 'ring-pro-us-stats-disclaimer';

const disclaimerCenterOffset = (target: HTMLElement) =>
  -(window.innerHeight - target.offsetHeight) / 2;

export const scrollToRingProUsStatsDisclaimer = () => {
  const target = document.getElementById(RING_PRO_US_STATS_DISCLAIMER_ID);
  if (!target) return;
  const lenis = getHomepageLenis();
  if (lenis) {
    lenis.scrollTo(target, { offset: disclaimerCenterOffset(target) });
    return;
  }
  target.scrollIntoView({ behavior: 'smooth', block: 'center' });
};
